declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    gtag?: (...args: unknown[]) => void;
  }
}

const adsId = process.env.REACT_APP_GOOGLE_ADS_ID;
const leadLabel = process.env.REACT_APP_GOOGLE_ADS_LEAD_LABEL;

// Called when the contact form is submitted successfully.
// Pushes a GTM event and, when a label is configured, reports the Google Ads conversion directly.
export const trackLeadFormSuccess = () => {
  if (!adsId) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "lead_form_success" });

  if (leadLabel && typeof window.gtag === "function") {
    window.gtag("event", "conversion", { send_to: `${adsId}/${leadLabel}` });
  }
};

export {};
